<template>
  <div class="settings-password">
    <div class="settings-card-top"></div>

    <div class="settings-card-body">
      <br />
      <h4>Cambiar contraseña</h4>
      <p class="settings-subtitle">Actualiza tu contraseña de acceso de forma segura.</p>

      <div class="settings-grid password-grid">
        <div class="settings-field settings-field--old-password">
          <label>Contraseña actual</label>
          <input
            type="password"
            class="form-control"
            placeholder="Contraseña actual"
            v-model="form.oldPassword"
            @blur="v$.form.oldPassword.$touch()"
            :class="{ 'is-invalid': v$.form.oldPassword.$error }"
          />
          <div class="invalid-feedback d-block" v-if="v$.form.oldPassword.$error">
            <span v-if="v$.form.oldPassword.$errors.length">
              {{ v$.form.oldPassword.$errors[0].$message }}
            </span>
          </div>
        </div>

        <div class="settings-field settings-field--new-password">
          <label>Nueva contraseña</label>
          <input
            type="password"
            class="form-control"
            placeholder="Nueva contraseña"
            v-model="form.password"
            @blur="v$.form.password.$touch()"
            :class="{ 'is-invalid': v$.form.password.$error }"
          />
          <div class="invalid-feedback d-block" v-if="v$.form.password.$error">
            <span v-if="v$.form.password.$errors.length">
              {{ v$.form.password.$errors[0].$message }}
            </span>
          </div>
        </div>

        <div class="settings-field settings-field--confirm-password">
          <label>Confirmar contraseña</label>
          <input
            type="password"
            class="form-control"
            placeholder="Confirmar contraseña"
            v-model="form.passwordConfirmation"
            @blur="v$.form.passwordConfirmation.$touch()"
            :class="{ 'is-invalid': v$.form.passwordConfirmation.$error }"
          />
          <div class="invalid-feedback d-block" v-if="v$.form.passwordConfirmation.$error">
            <span v-if="v$.form.passwordConfirmation.$errors.length">
              {{ v$.form.passwordConfirmation.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>

      <div class="validate-error" v-if="serverErrorMessage">{{ serverErrorMessage }}</div>

      <div class="settings-actions">
        <button type="button" class="btn btn-light" @click="resetForm">Descartar cambios</button>
        <button type="button" class="btn btn-primary" @click="savePassword">Guardar contraseña</button>
      </div>
    </div>
  </div>
</template>

<script>
import accountService from '@/services/account';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, sameAs, helpers } from '@vuelidate/validators';

export default {
  name: 'SettingsChangePasswordSection',
  data() {
    return {
      form: {
        oldPassword: '',
        password: '',
        passwordConfirmation: '',
      },
      serverErrorMessage: '',
    };
  },
  validations() {
    return {
      form: {
        oldPassword: {
          required: helpers.withMessage('La contraseña actual es obligatoria', required),
        },
        password: {
          required: helpers.withMessage('La nueva contraseña es obligatoria', required),
          minLength: helpers.withMessage('La contraseña debe tener al menos 8 caracteres', minLength(8)),
        },
        passwordConfirmation: {
          required: helpers.withMessage('Confirma la nueva contraseña', required),
          sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.form.password)),
        },
      },
    };
  },
  setup() {
    const v$ = useVuelidate();
    return { v$ };
  },
  methods: {
    resetForm() {
      this.form.oldPassword = '';
      this.form.password = '';
      this.form.passwordConfirmation = '';
      this.serverErrorMessage = '';
      this.v$.$reset();
    },
    async savePassword() {
      this.serverErrorMessage = '';
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      try {
        const payload = {
          old_password: this.form.oldPassword,
          password: this.form.password,
          password_confirmation: this.form.passwordConfirmation,
        };

        const response = await accountService.changePassword(payload);

        if (response && response.type === 'success') {
          this.$toast.success(response.message || 'Contraseña actualizada correctamente.');
          this.resetForm();
          return;
        }

        this.serverErrorMessage = response?.message || 'No se pudo actualizar la contraseña.';
      } catch (error) {
        this.serverErrorMessage = error?.response?.data?.message || 'No se pudo actualizar la contraseña.';
      }
    },
  },
};
</script>
